import { styled } from "styled-components";

export const Thead = styled.thead`
  width: 100%;

  > tr {
    width: 100%;
  }
`;

export const Th = styled.th`
  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 12px;

    > p {
      color: ${({ theme }) => theme.colors.default[900]};
      font-size: 24px;
      line-height: 36px;
      font-weight: 700;
    }

    > span {
      color: ${({ theme }) => theme.colors.default[400]};
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
    }
  }
`;
